import React from "react";
import { Draggable } from "react-beautiful-dnd";
import { colors } from "../../../../../utils/stripeColors";
import { IoMdMove } from "react-icons/io";
import UploadImageIcon from "../../../../../components/Common/SvgIcons/CommonIcons/UploadImageIcon";
// import CrossIcon from "../../../Common/SvgIcons/SocialIcons/CrossIcon";
import DeleteIcon from "../../../../../components/Common/SvgIcons/TableIcons/DeleteIcon";
import EditIcon from "../../../../../components/Common/SvgIcons/TableIcons/EditIcon";
import { useSelector } from "react-redux";
import classes from "./AddQuizQuestions.module.scss";
import Input from "../../../../../components/Common/Input/Input";
import deleteQuizQuestion from "../../../../../api/manage/deleteQuizQuestion";
import Tooltip from "../../../../../components/Common/ToolTip/Tooltip";
import { FaPaperclip } from "react-icons/fa";
import { FormattedMessage } from "react-intl";
const AddQuizQuestions = ({
  questionsFields,
  questionListWatch,
  removeQuestion,
  errors,
  activeQuestionIndex,
  setActiveTab,
  setActiveQuestionIndex,
  reference,
  snapshot,
  shotclassType,
  handleThumbnailSelect,
  isDistributed,
  disabeldFieldsViewPath,
  isImagesCheckbox,
  trigger,
  isValid,
  setIsEditQuestion,
  saveQuestion,
  handleDeleteQuizQuestion,
  ...rest
}) => {
  const commonState = useSelector((state) => state.commonReducer);
  const { colors } = commonState;
  const getListStyle = (isDraggingOver) => ({
    marginBottom: isDraggingOver ? "4.6rem" : undefined,
    // marginTop: isDraggingOver ? "2rem" : "auto",
  });
 
  return (
    <div
      className={classes.AddQuizQuestions__questionFields}
      ref={reference}
      style={getListStyle(snapshot.isDraggingOver)}
      {...rest}
    >
      {questionsFields.map((question, index, questionArr) => {
        return (
          <React.Fragment key={question.id}>
            {activeQuestionIndex === index ? (
              <div
                className={
                  classes.AddQuizQuestions__questionFields__questionField
                }
              >
                <Input
                  name={`QuestionsList.${index}.Question`}
                  label="Write Question"
                  // labelMsg={index === 0 && "(Max : 250 Characters)"}
                  labelMsg="(Max : 250 Characters)"
                  placeholder="Enter Quiz Question"
                  labelColor={"light"}
                  error={errors?.QuestionsList?.[index]?.Question?.message}
                  errorPosition="absolute"
                  required={true}
                  type="textarea"
                  maxLength={250}
                  disabled={disabeldFieldsViewPath}
                  onChange={() => {
                    if (
                      errors?.QuestionsList?.message ||
                      errors?.QuestionsList?.[activeQuestionIndex]?.Question
                        ?.message
                      // !isValid
                    ) {
                      trigger([`QuestionsList`]);
                    }
                  }}
                />
                {questionListWatch?.[index]?.QuestionImage?.[0]?.Mediaid >
                  0 && (
                  <Tooltip
                    direction="bottom"
                    content={<FormattedMessage id="IMAGE_ATTACHED" />}
                  >
                    <div className={classes.attachedIcon}>
                      <FaPaperclip />
                    </div>
                  </Tooltip>
                )}
                {/* {questionListWatch.length > 0 && <div>asdf</div>} */}
                <Input
                  type="file"
                  name={`QuestionsList.${index}.QuestionImage`}
                  label="Add Image"
                  placeholder=" "
                  labelColor={"light"}
                  accept=".jpeg,.png,.bmp,.jpg"
                  error={errors?.QuestionsList?.[index]?.QuestionImage?.message}
                  errorPosition="absolute"
                  hidden={true}
                  fileInputIcon={UploadImageIcon}
                  width={10}
                  fileInputButtonWidth={8}
                  disabled={disabeldFieldsViewPath}
                  // fileInputName={
                  //   questionListWatch?.[index]?.QuestionImage?.FileName
                  // }
                  handleClickFileButton={() =>
                    handleThumbnailSelect(
                      `QuestionsList.${index}.QuestionImage`,
                      true
                    )
                  }
                  // gap={index === 0 ? 3.3 : 1.1}
                  // gap={
                  //   index === 0
                  //     ? questionListWatch?.[0]?.QuestionImage?.FileName
                  //       ? 1.5
                  //       : 3.3
                  //     : questionListWatch?.[index]?.QuestionImage?.FileName
                  //     ? 0
                  //     : 1.1
                  // }
                  gap={1.1}
                />
                {/* {index !== 0 && !isDistributed && (
                  <span
                    onClick={(e) => {
                      if (shotclassType !== "view") {
                        setIsEditQuestion(false);
                        removeQuestion(index);
                        if (question?.ID) {
                          handleDeleteQuizQuestion(question?.ID);
                        }
                        // saveQuestion();
                        setActiveQuestionIndex(() => -1);
                      }
                    }}
                    className={
                      classes.AddQuizQuestions__questionFields__questionField__removeIcon
                    }
                  >
                    {disabeldFieldsViewPath && (
                      <DeleteIcon fill={colors.theme} />
                    )}
                  </span>
                )} */}
                {index !== 0 && !isDistributed && (
                  <Tooltip
                    content={<FormattedMessage id="DELETE_TXT" />}
                    direction="bottom"
                  >
                    <span
                      onClick={(e) => {
                        if (shotclassType !== "view") {
                          handleDeleteQuizQuestion(index, question?.ID);
                        }
                      }}
                      className={
                        classes.AddQuizQuestions__questionFields__questionField__removeIcon
                      }
                    >
                      <DeleteIcon fill={colors.theme} />
                    </span>
                  </Tooltip>
                )}
                {index === questionArr.length - 1 &&
                  !errors?.QuestionsList?.[index]?.QuestionImage?.message &&
                  !errors?.QuestionsList?.[index]?.Question?.message && (
                    <div
                      className={
                        classes.AddQuizQuestions__questionFields__questionField__error
                      }
                    >
                      {errors?.QuestionsList?.message}
                    </div>
                  )}
              </div>
            ) : (
              <Draggable
                key={`QuizQuestion[${index}]`}
                draggableId={`quiz-question-${index}`}
                index={index}
              >
                {(provided, snapshot) => (
                  <div
                    className={
                      classes.AddQuizQuestions__questionFields__questionField
                    }
                    key={question.id}
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                  >
                    <div
                      className={
                        classes.AddQuizQuestions__questionFields__questionField__question
                      }
                    >
                      <span>{index + 1 + ". "}</span>
                      <span>{questionListWatch?.[index]?.Question}</span>
                      {/* <span>{index + 1 + ". "}</span>
                      {questionListWatch?.[index]?.Question} */}
                    </div>
                    {activeQuestionIndex === -1 && (
                      <div
                        className={
                          classes.AddQuizQuestions__questionFields__questionField__options
                        }
                      >
                        <Tooltip
                          content={
                            <FormattedMessage
                              id="MYCLASS_EDIT"
                              direction="bottom"
                            />
                          }
                        >
                          <div
                            onClick={() => {
                              setIsEditQuestion(true);
                              setActiveQuestionIndex(() => index);
                              setActiveTab(
                                () =>
                                  questionListWatch?.[index]?.ActiveQuestionType
                              );
                            }}
                            className={
                              classes.AddQuizQuestions__questionFields__questionField__options__icon
                            }
                          >
                            <EditIcon />
                          </div>
                        </Tooltip>
                        {/* {!disabeldFieldsViewPath && (
                          <div
                            onClick={() => {
                              if (shotclassType !== "view") {
                                setIsEditQuestion(false);
                                removeQuestion(index);
                                if (question?.ID) {
                                  handleDeleteQuizQuestion(question?.ID);
                                }
                                // saveQuestion();
                                setActiveQuestionIndex((_) => -1);
                              }
                            }}
                            className={
                              classes.AddQuizQuestions__questionFields__questionField__options__icon
                            }
                          >
                            <DeleteIcon />
                          </div>
                        )} */}
                        {!isDistributed && (
                          <Tooltip content={<FormattedMessage id="MYCLASS_DELETE" />} direction="bottom">
                            <div
                              onClick={() => {
                                if (shotclassType !== "view") {
                                  handleDeleteQuizQuestion(index, question?.ID);
                                }
                              }}
                              className={
                                classes.AddQuizQuestionArr__questionFields__questionField__options__icon
                              }
                            >
                              <DeleteIcon />
                            </div>
                          </Tooltip>
                        )}
                        {/* <div
                          className={
                            classes.AddQuizQuestions__questionFields__questionField__options__move
                          }
                          {...provided.dragHandleProps}
                        >
                          <IoMdMove />
                        </div> */}
                        {shotclassType !== "view" && (
                          <Tooltip content="Move" direction="bottom">
                            <div
                              className={
                                classes.AddQuizQuestionArr__questionFields__questionField__options__move
                              }
                              {...provided.dragHandleProps}
                            >
                              <IoMdMove />
                            </div>
                          </Tooltip>
                        )}
                      </div>
                    )}
                  </div>
                )}
              </Draggable>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default AddQuizQuestions;
